import { render, staticRenderFns } from "./InsurancePolicyExport.vue?vue&type=template&id=04553508&scoped=true"
import script from "./InsurancePolicyExport.vue?vue&type=script&lang=js"
export * from "./InsurancePolicyExport.vue?vue&type=script&lang=js"
import style0 from "./InsurancePolicyExport.vue?vue&type=style&index=0&id=04553508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04553508",
  null
  
)

export default component.exports